<ion-content>
    <div class="modal-header-menu">
      <div class="modal-header-menu-backbutton" (click)="onGoBack()">
        <ion-icon name="arrow-back-outline"></ion-icon>
         {{'BACK' | translate }}
      </div>
    </div>
    <br><br>
    <div style="display: flex;align-items: center;">
        <img style="width: 80px;height: 80px;margin-left: 5px;" src="../../../assets/Totalum_Symbol.png">
        <div style="font-size: 20px;padding: 5%;padding-left: 0%;color: rgb(61, 61, 61);">
            <span *ngIf="!edit"> {{ 'CREATE_NEW' | translate }}</span>
            <span *ngIf="edit">{{ 'EDIT' | translate }}</span>
            {{ 'SERVER' | translate }}
        </div>
    </div>

    <div style="padding:5%;margin-top: -30px;">

        <form [formGroup]="serverForm">

        <ion-list>

            <div>
                <ion-item lines="full" class="form-inputs-margin">
                    <ion-input 
                        type="text"
                        placeholder="Introduce the server identifier (e.g.: my-server)"
                        [clearInput]="true"
                        label="Name of the server (cannot be changed)" label-placement="stacked"
                        formControlName="name"
                        (ionInput)="toLowercase($event)"
                        [disabled]="edit"
                    ></ion-input>
                </ion-item>
                <div class="form-input-error" color="danger" *ngIf="serverForm.get('name')?.invalid && serverForm.get('name')?.touched">
                    <ng-container *ngIf="!serverForm.get('name')?.valid">

                        The name of the server must be between 4 and 35 characters, all in lowercase and cannot start with a number. The only special character enabled is "-".
                        <br>Examples: myserver, my-server, my-server-2, my-server-2-3
                    </ng-container>
                </div>
            </div>

            <div>
                <ion-item lines="full" class="form-inputs-margin">
                    <ion-input 
                        type="text"
                        placeholder="Introduce the server description"
                        [clearInput]="true"
                        label="Description" label-placement="stacked"
                        formControlName="description"
                    ></ion-input>
                </ion-item>
                <div class="form-input-error" color="danger" *ngIf="serverForm.get('description')?.invalid && serverForm.get('description')?.touched">
                    <ng-container *ngIf="!serverForm.get('description')?.valid">It is mandatory to enter a valid description of up to 200 characters.</ng-container>
                </div>
            </div>
        </ion-list>

        <br>
        <div *ngIf="!edit && !user?.customPrice" style="font-size: 18px;padding: 5px;border: solid 1px rgb(221, 221, 221);border-radius: 5px;background-color: rgb(247, 247, 247);">
            When creating the server, you will be charged <b>{{pricesServers.v1}}€ + VAT monthly</b> recurring to the card linked to your account.
        </div>

        <ion-spinner *ngIf="isLoading" name="lines"></ion-spinner>

        <ion-button *ngIf="!edit" [disabled]="isLoading" mode="ios" class="button-margin-top" (click)="onSubmit()">
            <ion-label>{{ 'CREATE_SERVER' | translate }}</ion-label>
        </ion-button>

        <ion-button *ngIf="edit" [disabled]="isLoading" mode="ios" class="button-margin-top" (click)="onEditServer()">
            <ion-label>{{ 'EDIT_SERVER' | translate }}</ion-label>
        </ion-button>

        </form>
    </div>

  </ion-content>